import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);
  return null;
}

export function AppLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <ScrollToTop />
      <Header />
      <div className="mx-auto flex w-full max-w-[1600px] flex-1 items-start">
        <Sidebar />
        <main className="min-w-0 flex-1 px-3 py-5 sm:px-5 sm:py-6">
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
}
